import { render, staticRenderFns } from "./ChangeCertificateTextSlidebar.vue?vue&type=template&id=8091dbda&scoped=true"
import script from "./ChangeCertificateTextSlidebar.vue?vue&type=script&lang=js"
export * from "./ChangeCertificateTextSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8091dbda",
  null
  
)

export default component.exports